import { Shield } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ImmediateActionRequired() {
  return <section data-section-id="225985" id="immediate-action-required" className="dark bg-destructive/10 text-foreground relative overflow-hidden py-24 px-4 sm:px-6 lg:px-8 border-t border-destructive/20">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/50 to-destructive/5 pointer-events-none" />

      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(220,38,38,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(220,38,38,0.05)_1px,transparent_1px)] bg-[size:3rem_3rem] pointer-events-none" style={{
      maskImage: "radial-gradient(ellipse 60% 60% at 50% 50%, #000 10%, transparent 100%)",
      WebkitMaskImage: "radial-gradient(ellipse 60% 60% at 50% 50%, #000 10%, transparent 100%)"
    }} />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[600px] aspect-square bg-destructive/10 rounded-lg blur-[100px] pointer-events-none" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center text-center">
        <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 text-foreground">
          Is your pet having a medical emergency?
        </h2>
        
        <Button size="lg" asChild className="h-14 px-8 text-base font-semibold bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/20 transition-transform hover:scale-105 rounded-lg">
          <Link to="/EmergencyPharmacyPage">
            Call City Pet Care Now
            <Shield className="ml-2 w-5 h-5" />
          </Link>
        </Button>
      </div>
    </section>;
}